import { useQuery } from '@tanstack/react-query';

import type { RewardsCatalogStatus } from '~/services/RewardsService';
import { fetchCatalogs } from '~/services/RewardsService';

import { rewardsQueryKeys } from './rewardsQueryKeys';

/** Fetches reward catalogs, optionally filtered by itemType and status. */
export function useGetRewardsCatalogs(filters?: { itemType?: string; status?: RewardsCatalogStatus }) {
  return useQuery({
    queryKey: rewardsQueryKeys.catalogsList(filters ?? {}),
    queryFn: () => fetchCatalogs(filters),
  });
}
